module.exports = __webpack_public_path__ + "img/medal3.291a038f.svg";